'use client';

import { ThemeToggle } from '@/components/ui/ThemeToggle';

import { Footer } from './Footer';
import { Navigation } from './Navigation';

interface MarketingLayoutProps {
  children: React.ReactNode;
  isLoading?: boolean;
  isSignedIn?: boolean;
}

export default function MarketingLayout({
  children,
  isLoading = false,
  isSignedIn = false,
}: MarketingLayoutProps) {
  return (
    // `data-prerender-ready` flips on once real content (not the loading skeleton) is
    // shown. scripts/prerender.ts waits on this selector before snapshotting, so the
    // static HTML always captures rendered content, never a skeleton.
    <div
      className="bg-background flex min-h-screen flex-col"
      data-prerender-ready={isLoading ? undefined : 'true'}
    >
      <Navigation isLoading={isLoading} isSignedIn={isSignedIn} />
      {/* flex-1 grows the main area so the footer stays pinned to the bottom on short
          pages instead of floating up mid-screen. */}
      <main className="flex-1">{children}</main>
      <Footer isLoading={isLoading} />
      <ThemeToggle />
    </div>
  );
}
